"use client";

import classNames from "classnames";
import { RootState } from "interfaces/generics.type";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";
import isHighTrafficPage from "util/helper/isHighTrafficPage";
import isHomePage from "util/helper/isHomePage";
import { validateVehicle } from "util/vehicle/validate-vehicle";
import styles from "./styles.module.scss";

export function StyledOverlayBox(props: any) {
  const { isCompactGarage } = props;
  const { selectedVehicle } = useSelector((state: RootState) => state.garage);

  const router = useRouter();
  const { pathname } = router;
  const isItHomePage = isHomePage(pathname);
  const isItHighTrafficPage = isHighTrafficPage(router);

  return (
    <div
      className={classNames(styles.wrapper, {
        [styles.category_page_vehicle_selector]: !isItHomePage && !isItHighTrafficPage,
        [styles.category_page_vehicle_selected]: validateVehicle(selectedVehicle) && !isItHomePage && !isItHighTrafficPage,
      })}
    >

      <div className={`${styles.fluid} container-fluid`}>

        <div className={classNames(styles.overlay, {
          [styles.compact_garage_overlay]: isCompactGarage,
        })}
        >
          {props.children}

        </div>
      </div>
    </div>
  );
}
